import { createTheme } from '@material-ui/core';

export const themeMobimoTest = createTheme({
	palette: {
		primary: {
			main: '#279393',
		},
		secondary: {
			main: '#43A8A8',
		},
		background: {
			default: '#279393',
		},
	},
});
